import { useEffect } from 'react';
import { apiHolder } from 'api';
import useCreateCallbackForEvent from './useCreateCallbackForEvent';
const eventApi = apiHolder.api.getEventApi();
const useMsgRenderCallback = (eventName, callback) => {
    const callbackRef = useCreateCallbackForEvent(callback);
    useEffect(() => {
        const id = eventApi.registerSysEventObserver(eventName, {
            func: e => {
                callbackRef(e);
            },
        });
        return () => {
            eventApi.unregisterSysEventObserver(eventName, id);
        };
    }, []);
};
export default useMsgRenderCallback;
